/** 按年月日解析生日，避免 iOS 对非标准日期字符串的解析差异。 */
export function parseBirthday(value) {
  const parts = typeof value === "string" && /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(value);
  if (!parts) return NaN;

  const year = Number(parts[1]);
  const month = Number(parts[2]);
  const day = Number(parts[3]);
  // 使用本地年月日构造时间，保持原有生日毫秒时间戳语义。
  const date = new Date(0);
  date.setFullYear(year, month - 1, day);
  date.setHours(0, 0, 0, 0);
  // 回查年月日，拒绝非法日期被自动滚动到下个月的情况。
  if (year < 1 || date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return NaN;
  }
  return date.getTime();
}
